import keymirror from 'keymirror';
import { AsyncRequest } from 'angieslist-app-platform';

export default keymirror({
  ...AsyncRequest.createActionKeys('GET_CATEGORIES'),
  ...AsyncRequest.createActionKeys('GET_SHOWCASE'),
  ...AsyncRequest.createActionKeys('SAVE_SHOWCASE'),
  ...AsyncRequest.createActionKeys('SAVE_MEDIA'),
  ...AsyncRequest.createActionKeys('SAVE_MEDIA_ORDER'),
  ...AsyncRequest.createActionKeys('SAVE_SHOWCASE_ORDER'),
  ...AsyncRequest.createActionKeys('PUBLISH_SHOWCASE'),
  ...AsyncRequest.createActionKeys('DELETE_MEDIA'),
  ...AsyncRequest.createActionKeys('ADD_IMAGE_FROM_GALLERY'),
  ...AsyncRequest.createActionKeys('UPDATE_SHOWCASE_MEDIA'),
  ...AsyncRequest.createActionKeys('GET_REVIEWS'),
  ...AsyncRequest.createActionKeys('ATTACH_REVIEW'),
});



// WEBPACK FOOTER //
// ./src/modules/showcase/common/showcaseActionKeys.js